import React from 'react';
import { HamburgerMenu } from '../components/HamburgerMenu';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { motion } from 'framer-motion';
import { Coffee, Users, Heart, MapPin } from 'lucide-react';
export function AboutUs() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#D97E3A] selection:text-white" data-id="element-107">
      <HamburgerMenu data-id="element-108" />

      <main data-id="element-109">
        {/* Hero Section */}
        <section className="relative h-[70vh] w-full overflow-hidden flex items-center justify-center" data-id="element-110">
          <div className="absolute inset-0 z-0" data-id="element-111">
            <img src="https://images.unsplash.com/photo-1442512595367-42736f3e576a?q=80&w=2670&auto=format&fit=crop" alt="Coffee shop interior" className="w-full h-full object-cover opacity-30 grayscale contrast-125" data-id="element-112" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/40 to-[#0a0a0a]" data-id="element-113" />
            <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')] mix-blend-overlay" data-id="element-114" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="relative z-10 text-center px-4" data-id="element-115">
            <span className="text-[#D97E3A] font-inter font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-116">
              Since 2023
            </span>
            <h1 className="font-bebas text-white leading-[0.85] tracking-tight text-[15vw] lg:text-[10rem]" data-id="element-117">
              OUR STORY
            </h1>
          </motion.div>
        </section>

        {/* Content Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto" data-id="element-118">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-119">
            {/* Left Column - Text */}
            <div className="space-y-12" data-id="element-120">
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} data-id="element-121">
                <h2 className="font-bebas text-4xl md:text-5xl mb-6 text-[#D97E3A]" data-id="element-122">
                  ROOTED IN LIVERMORE
                </h2>
                <p className="font-inter text-lg text-white/70 leading-relaxed mb-6" data-id="element-123">
                  Grounded began with a simple idea: that a coffee shop should
                  be more than just a place to get caffeine. It should be the
                  living room of the neighborhood, a space where connections are
                  made and community is strengthened.
                </p>
                <p className="font-inter text-lg text-white/70 leading-relaxed" data-id="element-124">
                  Founded in 2023 by Livermore locals, we set out to create a
                  space that reflects the authentic spirit of our town. No
                  pretension, just exceptional coffee served with genuine
                  hospitality.
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} data-id="element-125">
                <h2 className="font-bebas text-4xl md:text-5xl mb-6 text-[#D97E3A]" data-id="element-126">
                  OUR PHILOSOPHY
                </h2>
                <p className="font-inter text-lg text-white/70 leading-relaxed" data-id="element-127">
                  We believe in the power of "slow coffee" in a fast world.
                  Taking the time to source ethically, roast carefully, and brew
                  precisely. But most importantly, taking the time to know our
                  customers by name and drink.
                </p>
              </motion.div>
            </div>

            {/* Right Column - Stats/Values */}
            <div className="space-y-8" data-id="element-128">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} className="bg-[#111] p-8 border border-white/5 relative overflow-hidden group hover:border-[#D97E3A]/30 transition-colors" data-id="element-129">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-130">
                  <Coffee size={100} data-id="element-131" />
                </div>
                <h3 className="font-bebas text-3xl mb-2" data-id="element-132">QUALITY FIRST</h3>
                <p className="font-inter text-white/60" data-id="element-133">
                  Sourcing only the finest beans from sustainable farms.
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="bg-[#111] p-8 border border-white/5 relative overflow-hidden group hover:border-[#D97E3A]/30 transition-colors" data-id="element-134">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-135">
                  <Users size={100} data-id="element-136" />
                </div>
                <h3 className="font-bebas text-3xl mb-2" data-id="element-137">COMMUNITY DRIVEN</h3>
                <p className="font-inter text-white/60" data-id="element-138">
                  Hosting local events, art shows, and gatherings.
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="bg-[#111] p-8 border border-white/5 relative overflow-hidden group hover:border-[#D97E3A]/30 transition-colors" data-id="element-139">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-140">
                  <Heart size={100} data-id="element-141" />
                </div>
                <h3 className="font-bebas text-3xl mb-2" data-id="element-142">LOCALLY OWNED</h3>
                <p className="font-inter text-white/60" data-id="element-143">
                  Built by neighbors, for neighbors.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Team/Values Grid */}
        <section className="py-24 bg-[#111] border-y border-white/5" data-id="element-144">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24" data-id="element-145">
            <div className="text-center mb-16" data-id="element-146">
              <h2 className="font-bebas text-5xl md:text-7xl mb-4" data-id="element-147">
                THE <span className="text-[#D97E3A]" data-id="element-148">TEAM</span>
              </h2>
              <p className="font-inter text-white/60 max-w-2xl mx-auto" data-id="element-149">
                Passionate baristas, skilled roasters, and community builders.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-150">
              {[1, 2, 3].map(i => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="group relative aspect-[3/4] overflow-hidden bg-[#0a0a0a]" data-id="element-151">
                  <img src={`https://images.unsplash.com/photo-${i === 1 ? '1583336130106-780658299015' : i === 2 ? '1512485694743-9c9538b4e6e0' : '1507914372817-940811243d44'}?q=80&w=800&auto=format&fit=crop`} alt="Team member" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-152" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-80" data-id="element-153" />
                  <div className="absolute bottom-0 left-0 p-6" data-id="element-154">
                    <h3 className="font-bebas text-2xl text-white" data-id="element-155">
                      TEAM MEMBER {i}
                    </h3>
                    <p className="font-inter text-sm text-[#D97E3A]" data-id="element-156">Barista</p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </section>

        <NewsletterSignup data-id="element-157" />

        {/* Footer */}
        <footer className="border-t border-white/10 py-12 text-center bg-[#0a0a0a]" data-id="element-158">
          <p className="font-bebas text-2xl text-white/50" data-id="element-159">
            © {new Date().getFullYear()} GROUNDED LIVERMORE
          </p>
        </footer>
      </main>
    </div>;
}